module.exports = __webpack_public_path__ + "files/efbca8131145403b24fc310805f2ab0f.png";